import { useCallback } from 'react';

import { TrackingApi } from 'api/TrackingApi';
import { getScreenOrientationWithSizes } from 'helpers/device';

const EVENT_INFO = 'message_notif_click';

export const useNotificationAnalytics = () => {
  const trackClickOnNotification = useCallback(() => {
    TrackingApi.trackClick({
      info: EVENT_INFO,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  return {
    trackClickOnNotification,
  };
};
